export default __webpack_public_path__ + "static/media/icon-socket.e1b51e25.svg";